import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { Redirect } from 'react-router-dom';
import IconPage from './IconPage';
import LoginPage from './LoginForm';
import Theme from '../ui/Theme';
import { AuthContext } from '../../Context/AuthContext';

const useStyles = makeStyles(() => ({
  paper: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    boxShadow: '0px 0px 0px 0px',
  },
  iconPage: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: Theme.palette.secondary.main,
  },
}));

const Login = () => {
  const classes = useStyles();
  const { isLoggedIn } = useContext(AuthContext);

  if (isLoggedIn) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Grid container alignItems="center" justifyContent="center" style={{ minWidth: '900px', overflowX: 'auto' }}>
      <Grid item xs={6}>
        <Paper className={classes.iconPage}>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item style={{ paddingBottom: '50px' }}>
              <IconPage />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper className={classes.paper}>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item style={{ paddingBottom: '50px' }}>
              <LoginPage />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Login;
